
import { Component, Vue } from "vue-property-decorator"
import { Route } from "vue-router"

@Component({
    components: {
        GroupList: () => import("@/components/misc/GroupList.vue")
    },
    beforeRouteLeave(to: Route, from: Route, next: any) {
        var view: any = this as GroupSettingsView
        if (view.groupList.changeInterval) {
            view.saving = true
            clearTimeout(view.groupList.changeInterval)
            var saved = view.groupList.doSave()
            if (saved) {
                saved.then(() => {
                    return next()
                })
            }
            return next(false)
        }
        return next()
    }
})
export default class GroupSettingsView extends Vue {
    saving: boolean = false

    get groupList() {
        return this.$refs.groupList as any & {
            verifySaved: () => boolean
            doSave: () => boolean
            changeInterval: any
        }
    }
}
